import { fetchGet } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const fetchGuidesApi = async (phoneId) => {
  const academyApiUrl = await getParam('academyApiUrl')
  return fetchGet(`${academyApiUrl}guides`, { phoneId })
}
